import { createEvmActionSource, isHex } from '@0xtorch/evm'
import { createSolanaActionSource } from '@0xtorch/solana'
import {
  ApiSecretRequiredException,
  SubTypeRequiredException,
} from '../../errors'
import type { FetchApiData } from '../../types'
import { networkEvmChainIds, solanaNetwork } from '../constants'
import { createClient } from '../createClient'
import { responseSchema } from './schema'

export const fetchApiData: FetchApiData = async ({
  apiKey,
  apiSecret,
  config,
  from,
  createHeaders,
  proxy,
  subType,
  to,
}) => {
  if (!apiSecret) {
    throw new ApiSecretRequiredException()
  }
  if (!subType) {
    throw new SubTypeRequiredException()
  }

  const client = createClient({
    apiKey,
    apiSecret,
    createHeaders,
    proxy,
  })

  const response = await client.run({
    method: 'GET',
    path: '/v1/user/deposit_history',
    query: {
      asset: subType,
      count: config.limit.toString(),
      ...(from ? { since: from.toString() } : {}),
      ...(to ? { end: to.toString() } : {}),
    },
    responseSchema,
  })

  // 昇順 sort
  const sortedHistories = response.data.deposits.sort(
    (a, b) => a.found_at - b.found_at,
  )

  // データ処理
  let stopped = false
  let fetchedFrom: number | undefined
  let fetchedTo: number | undefined
  const sources: string[] = []
  for (const history of sortedHistories) {
    // Check status
    if (history.status !== 'DONE') {
      stopped = true
      break
    }

    // Update fetchedFrom and fetchedTo
    fetchedFrom =
      fetchedFrom === undefined
        ? history.found_at
        : Math.min(fetchedFrom, history.found_at)
    fetchedTo =
      fetchedTo === undefined
        ? history.found_at
        : Math.max(fetchedTo, history.found_at)

    // Create EVM source
    const evmChainId = history.network
      ? networkEvmChainIds[history.network]
      : undefined
    if (history.txid && isHex(history.txid) && evmChainId) {
      sources.push(
        createEvmActionSource({
          chainId: evmChainId,
          transactionHash: history.txid,
        }),
      )
    }

    // Create Solana source
    if (history.network === solanaNetwork && history.txid) {
      sources.push(createSolanaActionSource({ signature: history.txid }))
    }
  }

  return {
    actions: [],
    count: response.data.deposits.length,
    from: fetchedFrom,
    sources,
    stopped,
    to: fetchedTo,
  }
}
